import React from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as DefaultSvg } from "../assets/images/Donation_sucess.svg";
import { ReactComponent as SuccessGreenSvg } from "../assets/images/success_green.svg";
import { ReactComponent as SuccessRedSvg } from "../assets/images/success_red.svg";

function DonationStatus({ donationStatus, onResubmit }) {
  const navigate = useNavigate();
  if (!donationStatus || donationStatus === "NONE") return null;

  const status = donationStatus.toUpperCase();

  const config = {
    VERIFIED: {
      title: "Donation Verified",
      subtitle: "Status: Verified",
      desc: "Your donation details have been successfully verified by the admin. Your profile is now approved and the donation button is active on your profile.",
      color: "#28a745",
    },
    REQUESTED: {
      title: "Request Submitted!",
      subtitle: "Status: Pending Review",
      desc: "Our admin will review your donation details shortly. This usually takes 24–48 hours. You will be notified once the verification is completed.",
      color: "#ff7a00",
    },
    REJECTED: {
      title: "Verification Rejected",
      subtitle: "Status: Rejected",
      desc: "Your donation verification was rejected by the admin. Please re-submit correct details and upload a valid UPI or QR code.",
      color: "#dc3545",
    },
  };

  const data = config[status] || config.REQUESTED;

  return (
    <div className="col-12 col-md-9 p-0">
      <div className="donation_status_container text-center">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="mb-4 d-flex justify-content-center">
                {status === "VERIFIED" && (
                  <SuccessGreenSvg width="120" height="120" />
                )}

                {status === "REJECTED" && (
                  <SuccessRedSvg width="120" height="120" />
                )}

                {status === "REQUESTED" && (
                  <DefaultSvg
                    width="120"
                    height="120"
                    style={{ fill: data.color }}
                  />
                )}
              </div>
              <h2 className="fw-bold mb-2" style={{ color: data.color }}>
                {data.title}
              </h2>
              <span
                className="px-3 py-1 rounded-pill d-inline-block mb-3"
                style={{
                  backgroundColor: `${data.color}15`,
                  color: data.color,
                  fontWeight: 500,
                }}
              >
                {data.subtitle}
              </span>
              <p
                className="text-muted mx-auto mt-3 w-100"
                style={{
                  maxWidth: "900px",
                  lineHeight: "1.8",
                  fontSize: "16px",
                }}
              >
                {data.desc}
              </p>

              <div className="mt-4 d-flex justify-content-center gap-3 flex-wrap">
                {status === "REJECTED" && (
                  <button
                    className="btn btn-danger px-4 py-2 rounded-pill fw-semibold"
                    onClick={onResubmit}
                  >
                    Re-submit Donation Details
                  </button>
                )}
                <button
                  className="btn px-4 py-2 rounded-pill fw-semibold"
                  style={{
                    border: "2px solid #ff7a00",
                    color: "#ff7a00",
                    background: "transparent",
                  }}
                  onClick={() => navigate("/feed/prime")}
                >
                  Back To Feed
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DonationStatus;
